import { render } from "./Products.vue?vue&type=template&id=249f1388&scoped=true"
import script from "./Products.vue?vue&type=script&lang=js"
export * from "./Products.vue?vue&type=script&lang=js"

import "./Products.vue?vue&type=style&index=0&id=249f1388&scoped=true&lang=css"

import exportComponent from "/Users/renzocappelli/Lavoro/bikinilovers/newPosBKL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-249f1388"]])

export default __exports__